import { wrap as withStyle, stylesIf, themeColor } from 'utils/styles'

export default withStyle(
  ({ width, backgroundColor = 'white', disabled, theme }) => `
    width: ${width}px;
    height: ${width}px; /* So background color only paints over the circle*/
    border-radius: ${width / 2}px; 
    background-color: ${backgroundColor};
    cursor: pointer;
    ${stylesIf(
      disabled,
      `
      cursor: default;
      && > path {
        fill: ${themeColor('grey', { theme })}
      }
      `
    )}
  `
)
